import { HeaderConstants } from '../../navigation/model/HeaderConstants';

const DESKTOP_HEADER_SUBNAV_PX = (HeaderConstants.NAV_TABS_HEIGHT * 2 + HeaderConstants.NAV_TABS_GAP_HEIGHT) * 16;

const DESKTOP_HEADER_MAIN_NAV_PX = (HeaderConstants.UNIFY_BAR_HEIGHT + HeaderConstants.NAV_BAR_HEIGHT) * 16;

const DESKTOP_HEADER_PX = DESKTOP_HEADER_SUBNAV_PX + DESKTOP_HEADER_MAIN_NAV_PX;

const VIEWABLE_FILE_EXTENSION = [
  // Images
  '.gif',
  '.jpeg',
  '.jpg',
  '.png',
  '.svg',

  // Text
  '.txt',

  // Documents
  '.pdf',
];

const NON_VIEWABLE_FILE_EXTENSION = [
  // Video
  '.asf',
  '.avi',
  '.m4v',
  '.mov',
  '.mp4',
  '.mpeg',
  '.mpg',
  '.wmv',

  // Images
  '.ai',
  '.avif',
  '.bmp',
  '.eps',
  '.heic',
  '.heif',
  '.indd',
  '.psd',
  '.raw',
  '.tif',
  '.tiff',

  // Audio
  '.aac',
  '.aiff',
  '.alac',
  '.flac',
  '.m4a',
  '.mp3',
  '.wav',
  '.wma',

  // Text
  '.csv',
  '.rtf',

  // Documents
  '.doc',
  '.docm',
  '.docx',
  '.dot',
  '.dotm',
  '.dotx',
  '.eml',
  '.hwp',
  '.msg',
  '.odc',
  '.pbix',
  '.pbix',
  '.ppt',
  '.pptx',
  '.xls',
  '.xlsx',
];

const UPLOADABLE_FILE_EXTENSIONS = [...VIEWABLE_FILE_EXTENSION, ...NON_VIEWABLE_FILE_EXTENSION];

export const StudyDocumentsConstants = {
  DESKTOP_HEADER_SUBNAV_PX,
  DESKTOP_HEADER_MAIN_NAV_PX,
  DESKTOP_HEADER_PX,
  VIEWABLE_FILE_EXTENSION,
  NON_VIEWABLE_FILE_EXTENSION,
  UPLOADABLE_FILE_EXTENSIONS,
} as const;
